import React from "react";
import CommonStatePage from "./CommonStatePage";

const NotFoundPage = () => {
  return (
    <CommonStatePage
      type="notFound"
      code="404"
      title="Page Not Found"
      description="The page you are looking for does not exist, has been removed, or the URL may be incorrect."
      primaryButtonText="Go to Home"
      primaryButtonPath="/"
    />
  );
};

export default NotFoundPage;
